<template>
    <div class="con">
        <div class="banner">
            <img src="../assets/yr/nbanner.png" alt="">
        </div>
        <div class="blog" >
            <p class="title">{{$t('home').text9}}</p>
            <div class="lines">
                <span></span>
                <span class="t"></span>
                <span></span>
            </div>
            <div class="mainCon">
                <div class="item" v-for="(item,index) in blogList" :key="index">
                    <router-link :to="{path: 'blogInfo',query:{id:item.ID}}" >
                        <img :src="`http://www.yourlonglighting.com/upload/${item.SMALLPIC}`" alt="">
                        <p class="t1">{{item.TITLE}}</p>
                        <p class="t2">{{item.ZY}}</p>
                        <p class="t3">{{$t('home').text10}}</p>
                        <div class="time">
                            <p>{{item.time2}}</p>
                            <p class="ti">{{item.SHOWTIME}}</p>
                        </div>
                    </router-link>
                </div>
            </div>
            <div style="text-align: center;margin-top: 60px" @click="showMore">
                <btn-Component :text="$t('btn')"></btn-Component>
            </div>
        </div>
        <foot-Component></foot-Component>
    </div>
</template>

<script>
    import footComponent from '../components/foot'
    import btnComponent from '../components/btn'
    import { getNewsUrl} from '../util/lang'
    export default {
        name: "news",
        data(){
            return{
                page:'',
                id:'',
                totalPage:'',
                blogList:[]
            }
        },
        components:{footComponent,btnComponent},
        mounted() {
            if(this.$i18n.locale==='en') {
                this.getNews('38')
            }else{
                this.getNews('40')
            }
        },
        methods:{
            showMore(){
                if(this.page<=this.totalPage){
                    const url = `${getNewsUrl( this.$i18n.locale,this.id,6,this.page++)}`
                    this.$axios.get(url).then(res => {
                        res.data.newsArr.map((item)=>{
                          item.time2=item.SHOWTIME.substring(8,10)
                          item.SHOWTIME=item.SHOWTIME.substring(0,7)
                        })
                        this.blogList=this.blogList.concat(res.data.newsArr)
                    })
                }else{
                    this.$notify({
                        title: 'Prompt',
                        message: 'Already loaded',
                        offset: 100
                    });
                }
            },
            getNews(id){
                this.page=2
                this.id=id
                const url = `${getNewsUrl(this.$i18n.locale,id,6,1)}`
                this.$axios.get(url).then(res => {
                    res.data.newsArr.map((item)=>{
                        item.time2=item.SHOWTIME.substring(8,10)
                        item.SHOWTIME=item.SHOWTIME.substring(0,7)
                    })
                    this.blogList= res.data.newsArr
                    this.totalPage=res.data.pagerShow.totalPagers
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .con {
        width: 100%;
        animation: down 2s linear;
        @keyframes down {
            from{
                transform: translateX(-30px);
            }
            to{
                transform: translateX(0);
            }
        }
        .banner {
            width: 100%;
          overflow: hidden;
            img {
                width: 100%;
                object-fit: cover;
                display: block;
                animation: big 1s linear forwards;
            }
            @keyframes big {
                from{
                    transform: scale(1.1);
                }
                to{
                    transform: scale(1);
                }
            }
        }
        .blog{
            width:1280px;
            margin: 0 auto;
            padding: 30px 0;
            .title{
                text-align: center;
                font-family:Calibri;
                font-size: 25px;
                text-transform: uppercase;
                margin-block-end: 0.5em;
            }
            .lines{
                width:100%;
                text-align: center;
                display: flex;
                flex-direction: column;
                align-items: center;
                span{
                    display: inline-block;
                    width:12px;
                    height:1px;
                    background-color: rgba(0,0,0,.6);
                    margin-top:5px;
                }
                .t{
                    width:8px;
                    background-color: rgba(0,0,0,.3);
                }
            }
            .mainCon{
                width:100%;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                margin-top: 60px;
                .item{
                    width:30%;
                    background-color: #FAFAFA;
                    position: relative;
                    cursor: pointer;
                    transition: all 600ms;
                    margin-top: 40px;
                    a{
                        color:black;
                    }
                    img{
                        width:100%;
                        object-fit: cover;
                    }
                    p{
                        width:90%;
                        margin-left: 5%;
                    }
                    .t1{
                        font-family:Calibri;
                        font-size: 20px;
                        transition: all 600ms;
                        line-height: 25px;
                    }
                    .t2{
                        font-family:Calibri;
                        font-size: 14px;
                        line-height: 30px;
                        text-transform: capitalize;
                    }
                    .t3{
                        text-align: right;
                        font-family:Calibri;
                        font-size: 18px;
                        text-transform: uppercase;
                        transition: all 600ms;
                    }
                    .time{
                        position: absolute;
                        top:0;
                        width:20%;
                        left:10%;
                        display: flex;
                        flex-direction: column;
                        background-color: rgba(0,0,0,.8);
                        color:white;
                        font-family:Calibri;
                        font-size: 30px;
                        padding: 10px 0;
                        p{
                            margin-block-start: 0;
                            margin-block-end: 0;
                            text-align: center;
                        }
                        .ti{
                            font-size: 20px;
                        }
                    }
                }
                .item:not(first-child){
                    margin-left: 2%;
                }
                .item:hover{
                    transform:translateY(-20px);
                    .t1,.t3{
                        color:#F4A000;
                    }
                }
            }
        }
        @media screen and (max-width:450px){
            .banner {
                img {
                    height: 300px;
                }
            }
            .blog{
                width:95%;
                .mainCon{
                    flex-direction: column;
                    .item{
                        width:100%;
                        margin-left: 0 !important;
                    }
                }
            }
        }
    }
</style>
